import axios from 'axios'

import { BASE_URL } from '@/constants/api'

export const axiosPlugin = axios.create({
  baseURL: BASE_URL,
})

export const axiosExternalPlugin = axios.create()

axiosPlugin.interceptors.request.use(
  (req) => {
    req.paramsSerializer = (params: unknown) => {
      if (params && Object.keys(params).length > 0) {
        const paramsObj = params as Record<string, unknown>
        return Object.keys(params)
          .map((key) => {
            const value = paramsObj[key]
            return `${key}=${JSON.stringify(value || '')}`
          })
          .join('&')
      }
      return params?.toString() || ''
    }

    return req
  },
  (error) => {
    console.error(`[api-call]: ${error.message} (${error.code})`)
    return Promise.reject(error)
  },
)

axiosPlugin.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error('[API Response Error]:', error.message)

    // Only redirect on unauthorized errors
    if (error.response?.status === 401) {
      window.location.href = '/login?error=unauthorized'
    }

    return Promise.reject(error)
  },
)

export default axiosPlugin
